module.exports = __webpack_public_path__ + "static/media/pic_xiazai.a6f2b3a2.png";